import styled from 'styled-components'

const InfoString = styled.span`
  font-size: 13px;
  letter-spacing: 0.8px;
  color: ${props => props.theme.text};
`
export default InfoString
